module.exports = __webpack_public_path__ + "media/images/icon_3-1d10453f59361f0a6ae9e024bc48d92e.svg";